import { PropertyData } from '@aloft/toolkit-shared';

const getMlsListingKey = (property: PropertyData): string | undefined => {
  const { mls, mlsListingID } = property.editableData.transaction;

  if (!mls || !mlsListingID?.trim()) return undefined;

  return `${property.compType ?? 'aiv'}:${mls}:${mlsListingID.trim()}`;
};

export const getDuplicateCompMlsListing = (
  currentComps: Record<string, PropertyData>,
  compSequence: string[],
  propertiesToAdd: PropertyData[],
): { index: number; property: PropertyData } | undefined => {
  const existingKeys = new Set(
    compSequence
      .map((id) => currentComps[id])
      .filter((property): property is PropertyData => property !== undefined)
      .map(getMlsListingKey)
      .filter((key): key is string => key !== undefined),
  );

  const newKeys = new Set<string>();

  for (const [index, property] of propertiesToAdd.entries()) {
    const key = getMlsListingKey(property);
    if (!key) continue;

    if (existingKeys.has(key) || newKeys.has(key)) return { index, property };
    newKeys.add(key);
  }

  return undefined;
};
